import { FC } from "react";
import { Column } from "../../../../containers";
import { AlignItems } from "../../../../containers/types";
import { IconAnimation } from "../../../../animation";
import { LogoutIcon, MoonIcon, SunIcon } from "../../../../../assets/icons";
import { useThemeStore, useUserStore } from "../../../../../stores";
import { Themes } from "../../../../../types";
import { useNavigate } from "react-router";

const NavFooter: FC = () => {
  const theme = useThemeStore((state) => state.theme);
  const swapTheme = useThemeStore((state) => state.swapTheme);
  const activeTheme = useThemeStore((state) => state.activeTheme);
  const userLogout = useUserStore((s) => s.userLogout);
  const navigate = useNavigate();

  const onLogout = (): void => {
    userLogout();
    navigate("/login");
  };

  return (
    <Column
      style={{ width: "100%", marginRight: 70, marginBottom: 20 }}
      gap={30}
      alignItems={AlignItems.Start}
    >
      <IconAnimation
        Icon={activeTheme === Themes.Dark ? SunIcon : MoonIcon}
        onHoverColor={theme.primary}
        width={24}
        height={24}
        className="cursor-pointer"
        onClick={swapTheme}
      />
      <IconAnimation
        Icon={LogoutIcon}
        onHoverColor={theme.alert}
        width={24}
        height={24}
        className="cursor-pointer"
        onClick={onLogout}
      />
    </Column>
  );
};

export default NavFooter;
